import { createSelector } from "reselect";

export const getObjectSelector = (state) => state?.object;

export const selectedStageSelector = createSelector(getObjectSelector, (object) => {
  let stage = 'about';
  if (!object) return stage;

  const hasDescription = !!object?.description?.description;
  const hasPhotos = object?.photo?.photos && object.photo.photos.length >= 5;
  const hasPhones = object?.contact?.phones && object.contact.phones.length > 0;
  const hasRooms = object?.rooms && object.rooms.length > 0;
  let hasServices = false;
  let hasRules = false;
  let hasPrices = false;

  if (object?.services) {
    for (let serviceKey in object.services) {
      if (hasServices) break;
      hasServices = !!(object.services[serviceKey] && object.services[serviceKey].values.filter(item => item.selected)[0]);
    }
  }

  if (object?.rules) {
    for (let ruleKey in object.rules) {
      if (hasRules) break;
      hasRules = !!(object.rules[ruleKey] && object.rules[ruleKey].values.filter(item => item.selected)[0]);
    }
  }

  if (object?.rooms) {
    hasPrices = !!object.rooms.filter(item => item.prices)[0];
  }
  if (!hasPrices) {
    stage = 'calendar';
  }
  if (!hasRooms) {
    stage = 'rooms';
  }
  if (!hasRules) {
    stage = 'rules';
  }
  if (!hasServices) {
    stage = 'services';
  }
  if (!hasPhones) {
    stage = 'contacts';
  }
  if (!hasPhotos) {
    stage = 'photos';
  }
  if (!hasDescription) {
    stage = 'about'
  }

  return stage;
});




